'use client';

import React from 'react';
import { VoiceQuality } from './useVoiceCall';

// Комментарий на русском: компонент выбора качества голоса

interface VoiceQualityPickerProps {
  value: VoiceQuality;
  onChange: (quality: VoiceQuality) => void;
  disabled?: boolean;
}

const QUALITY_OPTIONS: { value: VoiceQuality; label: string; description: string }[] = [
  { value: 'auto', label: 'Авто', description: 'Адаптивное качество' },
  { value: 'low', label: 'Низкое', description: '16-20 кбит/с' },
  { value: 'medium', label: 'Среднее', description: '24-32 кбит/с' },
  { value: 'high', label: 'Высокое', description: '40-48 кбит/с' },
];

export function VoiceQualityPicker({ value, onChange, disabled }: VoiceQualityPickerProps) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs text-site-muted dark:text-site-muted">Качество</label>
      <div className="flex gap-1">
        {QUALITY_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            disabled={disabled}
            title={option.description}
            className={`flex-1 px-2 py-1.5 text-xs rounded-lg transition-colors
              ${value === option.value
                ? 'bg-site-accent text-site-on-accent'
                : 'bg-site-raised dark:bg-site-raised text-site-muted dark:text-site-secondary hover:bg-site-raised dark:hover:bg-site-raised'
              }
              disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
